import { isMobile } from './common.js';

export default {
  init() {
    console.debug('landing subscription init');
    $('.single_add_to_cart_button').off('click.listen_product_type');

    /**
     * Accordion init
    */
    $('.accordion').accordionjs({
      // Allow self close.(data-close-able)
      closeAble: false,
      // Close other sections.(data-close-other)
      closeOther: true,
      // Animation Speed.(data-slide-speed)
      slideSpeed: 400,
      // The section open on first init. A number from 1 to X or false.(data-active-index)
      activeIndex: 1,
      // Callback when a section is open
      openSection: function () {
        // console.debug(section);
      },
      // Callback before a section is open
      beforeOpenSection: function () {
        // console.debug(section);
      },
    });

    function baseProductUI() {
      let $baseProduct = $('.base_product .bundled_product');
      let baseProductPrice = $baseProduct.find('.bundled_item_cart_details > .price');
      let baseProductButtonContainer = $baseProduct.find('.bundled_item_button');
      baseProductButtonContainer.append(baseProductPrice);
    }
    baseProductUI();

    /**
     * Build a list with products added to the subscription box along with quantity and prices
     * @description WC Bundle Products does not offer a cart-like view so we are building one by cloning the selected base/addon products and syncing every change (add/remove/quantity) the user makes.
    */
    function buildBoxTotals() {

      //Type of product vars
      let $baseProduct = $('.base_product .bundled_product');
      let $addonProduct = $('.addon_products .bundled_product');
      let $bundledProduct = $('.step .bundled_product');

      //Shared product vars
      let productTitle = '.item_title';
      let productQuantity = '.input-text.qty';
      let productPrice = '.price .amount > *:last-child() bdi';

      //Base product vars
      let baseProductTitle = '.bundled_product_title_inner';

      //Addon product vars
      let $addonAddButton = $addonProduct.find('.add-to-box');
      let addonCheckbox = '.bundled_product_checkbox';
      let addonAddButtonClasses = 'bg-green-500 text-white';

      //Clone vars
      let cloneClass = 'addon-clone';
      let $cloneWrapper = $('ul.box-contents');
      let cloneQuantity = 'clone-qty';
      let clonePrice = 'clone-price';
      let cloneTitle = 'clone-title';
      //@todo there must be a more decent way to build these selectors:
      let cloneQuantityClass = '.' + cloneQuantity;
      let clonePriceClass = '.' + clonePrice;
      // let cloneTitleClass = '.' + cloneTitle;
      let cloneID;

      function AddClone(product) {

        if (!product) { return; }

        //Get attributes from our original product
        let title = product.find(productTitle).length > 0 ? product.find(productTitle).text() : product.find(baseProductTitle).text();
        let quantity = product.find(productQuantity).val();
        let price = product.find(productPrice).text();
        console.log(price);
        getCloneIDFromProduct(product);

        //Put our clone together
        var clone = '<li id="' + cloneID + '" class="' + cloneClass + ' flex justify-between py-4 px-1">';
        clone += '<span class="w-1/12 ' + cloneQuantity + '">' + quantity + '</span>';
        clone += '<span class="w-9/12 px-2 ' + cloneTitle + '">' + title + '</span>';
        clone += '<span class="w-2/12 text-right ' + clonePrice + '">' + price + '</span>';
        clone += '</li>'

        var cloneHasBeenMatched = false;

        /**
         * Find out if we need to insert or update the clone:
         */

        //First, have we already added clones to the list ?
        if ($cloneWrapper.children('li').length > 0) {

          //Then iterate the list of existing clones
          $.each($cloneWrapper.children('li'), function () {
            //Has this one been cloned?
            if (cloneID == $(this).attr('id')) {
              //Then only update it
              updateClone(cloneID, $(this).attr('id'), quantity, price);
              cloneHasBeenMatched = true;
              return false;
            }
          });

          //This one has not been cloned yet, then clone it
          if (cloneHasBeenMatched == false) {
            $cloneWrapper.append(clone);
          }

        } else {
          //Clone list is empty, then clone it
          $cloneWrapper.append(clone);
        }

      }

      //Update quantity on clones when changed on products
      function updateClone(cloneID, addon_class, quantity, price) {
        var cloneToUpdate = $cloneWrapper.children('#' + cloneID);
        cloneToUpdate.find(cloneQuantityClass).text(quantity);
        cloneToUpdate.find(clonePriceClass).text(price);
      }

      //Remove a clone from the list
      function removeClone(product) {
        getCloneIDFromProduct(product);
        var cloneToRemove = $cloneWrapper.children('#' + cloneID);
        cloneToRemove.remove();
      }

      //Return a unique ID for our clone from the only unique product class: bundled_item_[number]
      function getCloneIDFromProduct(product) {
        let classList = product.attr('class');
        let classArr = classList.split(/\s+/);

        $.each(classArr, function (index, value) {
          if (value.includes('bundled_item_') && value !== 'bundled_item_optional') {
            cloneID = value;
          }
        });
        return cloneID;
      }

      //Listen for quantity changes
      $(productQuantity).on('change', function () {
        let thisCheckbox = $(this).closest($bundledProduct).find(addonCheckbox);

        //If it has a checkbox, it is an addon product
        if (thisCheckbox.length > 0) {
          //Is the checkbox checked?
          if (thisCheckbox.prop('checked')) {
            AddClone($(this).closest($bundledProduct));
          }
        } else {
          //Otherwise it is a base product
          console.log($(this));
          console.log($(this).closest($bundledProduct));
          AddClone($(this).closest($bundledProduct));
        }

      });

      //Sync clicks from the add-to-box button to its sibling hidden checkbox
      $addonAddButton.on('click', function (e) {

        let thisCheckbox = $(this).closest($addonProduct).find(addonCheckbox);
        thisCheckbox.click();
        if (thisCheckbox.prop('checked')) {
          AddClone($(this).closest($addonProduct));
          $(this).children('.text').text('Added to box')
          $(this).addClass(addonAddButtonClasses);
        } else {
          removeClone($(this).closest($addonProduct));
          $(this).children('.text').text('Add to box');
          $(this).removeClass(addonAddButtonClasses);
        }
        styleSelectedCheckboxParent(thisCheckbox, $(this).closest($addonProduct), 'shadow selected-option');
        e.preventDefault();
        e.stopPropagation();
        /*
        if (thisCheckbox.prop('checked')) {
          AddClone($(this).closest($addonProduct));
          $(this).children('.text').text('Added to box')
          $(this).addClass(addonAddButtonClasses);
        } else {
          removeClone($(this).closest($addonProduct));
          $(this).children('.text').text('Add to box');
          $(this).removeClass(addonAddButtonClasses);
        }
        styleSelectedCheckboxParent(thisCheckbox, $(this).closest($addonProduct), 'shadow selected-option');
        e.preventDefault();
        e.stopPropagation();
        */
      });

      //Clone the base product on load sintaxys
      console.log($baseProduct);
      AddClone($baseProduct);

    }
    buildBoxTotals();

    /**
     * Add styles to the parent's checkbox after it has been checked
     * @param {*} checkbox
     * @param {*} parent
     * @param {*} parent_class
     */
    function styleSelectedCheckboxParent(checkbox, parent, parent_class = '') {
      if (checkbox.prop('checked')) {
        parent.addClass(parent_class);
      } else {
        parent.removeClass(parent_class);
      }
    }

    /**
     * Move the subscription options inside .step-3
     * @description WC-APFS moves  the susbcription options wrapper if it is inside the form.cart container via javascript. So we are moving them back to where we need them. (Because they're doing it with JS, de-hooking and re-hooking them will not work here...)
     */
    function moveSubscriptionOptions() {
      let optionsWrapper = $('.wcsatt-options-wrapper');
      let newPosition = $('.step.step-3 .subscription-options');
      $(optionsWrapper).detach().appendTo(newPosition);
    }
    moveSubscriptionOptions();

    /**
     * Add listeners for click on next step buttons and step markers
     */
    function registerStepEvents() {
      let nextStepButtons = $('button[data-nextstep^="step-"]');
      let stepMarkers = $('[data-step^="step-"]');

      //Click on next step
      nextStepButtons.on('click', function (e) {
        let nextStepTarget = $(this).data('nextstep');

        // Things to do every next step
        $('#get-started').get(0).scrollIntoView();
        toggleMiniSummaryCartVisibility('close');
        setActiveStepMarker(nextStepTarget);
        toggleStepVisibility(nextStepTarget);
        e.preventDefault();
      });

      //Click on step markers
      stepMarkers.on('click', function (e) {
        let currentStep = $(this).data('step');
        toggleMiniSummaryCartVisibility('close');
        setActiveStepMarker(currentStep);
        toggleStepVisibility(currentStep);
        e.preventDefault();
      });

    }
    registerStepEvents();

    /**
     * Hide/show every step
     */
    function toggleStepVisibility(requestedStep) {
      console.debug('requested', requestedStep);
      switch (requestedStep) {
        case 'step-1':
          $('.steps-cart-wrap').fadeOut(400, function () {
            $('.step-1').fadeIn();
          });
          break

        case 'step-2':
          $('.step-1, .step-3').fadeOut(400, function () {
            if ($('.steps-cart-wrap').is(':hidden')) {
              $('.steps-cart-wrap')
                .css('display', 'flex')
                .hide()
                .fadeIn();
            }
            $('.step-2').fadeIn();
            wizardStep2Mobile();
          });
          break;

        case 'step-3':
          //Hide Choose Frequency button
          $('[data-nextstep="step-3"]').fadeOut();
          $('.step-2').fadeOut(400, function () {
            //Show step-3 container
            $('.step-3').fadeIn();
            //Change appearance from default `subscribe` button to match all next step buttons
            //@todo move to a hook instead ffs
            $('.bundle_add_to_cart_button').addClass('add-to-box hover:bg-primary w-full px-8 py-4 font-bold text-center text-white transition-colors bg-green-500 rounded uppercase font-sans text-base -mt-4').text('Go to checkout').fadeIn();
            wizardStep3Mobile();
          });
          break;
      }
    }

    /**
     * Indicate the current step in the markers
     * @param {*} step
     */
    function setActiveStepMarker(step) {
      const activeClass = 'active-step';
      const $StepMarkers = $('[data-step^="step-"]');
      $($StepMarkers).removeClass(activeClass);
      $('[data-step="' + step + '"]').addClass(activeClass);
    }

    /**
     * Hide/show mobile mini summary cart container
     * @param action optional | 'close' will force it to hide the cart, otherwise it will toggle it
     */
    function toggleMiniSummaryCartVisibility(action) {
      if (!isMobile) { return; }
      let chevron = $('.toggle-mini-summary');
      let cartWrapper = $('.cart.bundle_data');
      let cart = cartWrapper.children('.controls');
      chevron.toggleClass('rotate-180 text-primary');

      function toggleBodyScroll(activeCart) {
        if (activeCart.is(':hidden')) {
          // console.debug('mini cart is hidden');
          $('body').css('overflow', 'auto');
        } else {
          // console.debug('mini cart is visible');
          $('body').css('overflow', 'hidden');
        }
      }

      if (action == 'close') {
        cart.slideUp(400, function () {
          // console.debug('closed mini cart');
          toggleBodyScroll($(this));
        });
      } else {
        cart.slideToggle(400, function () {
          // console.debug('toggled mini cart');
          toggleBodyScroll($(this));
        });
      }

    }

    //Listen for clicks on mini summary toggle
    $('.toggle-mini-summary').on('click', function (e) {
      toggleMiniSummaryCartVisibility();
      e.preventDefault();
    });

    /**
      * UI updates when on step 2 in mobile
      */
    function wizardStep2Mobile() {
      if (!isMobile) { return; }
      updateMiniSummaryValues();
      console.debug('step-2 mobile')
    }

    /**
     * UI updates when on step 3 in mobile
     */
    function wizardStep3Mobile() {
      if (!isMobile) { return; }
      //Clone checkout button to mini summary
      $('.cart.bundle_data .single_add_to_cart_button').appendTo($('.mini-summary'));
      $('.mini-summary').find('.single_add_to_cart_button').removeClass('-mt-4 px-8');
      updateMiniSummaryValues();
      console.debug('step-3 mobile')
    }


    /**
     * Update mini summary price using the mini cart's
     */
    function updateMiniSummaryValues() {
      //A timeout was needed so we don't run the update before it actually takes place
      setTimeout(function () {
        let price = jQuery('.cart.bundle_data .bundle_price .price > *:last-child').text();
        jQuery('.mini-summary .price-amount').text(price);
        console.debug('mini summary values updated: ', price)
      }, 600);
    }

    //Listen for mini summary cart totals changes
    $('body').on('woocommerce-bundled-item-totals-changed', function () {
      // console.log('woocommerce-bundled-item-totals-changed triggered');
      updateMiniSummaryValues();
    });
    $('body').on('woocommerce-product-bundle-update', function () {
      // console.log('woocommerce-product-bundle-update triggered');
      updateMiniSummaryValues();
    });
    $('body').on('woocommerce-product-bundle-update-totals', function () {
      // console.log('woocommerce-product-bundle-update-totals triggered');
      updateMiniSummaryValues();
    });
    $('body').on('updated_addons', function () {
      // console.log('updated_addons triggered');
      updateMiniSummaryValues();
    });

    $('.js-product-subscription-trigger').modaal({
      content_source: '#product-subscription-modal',
    });

    $('#closeModal').on('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      $('.js-product-subscription-trigger').modaal('close');
      // Clear previous click selection (if any)
      $('.bundled_product_summary').removeClass('selected');

    });

    $('.bundled_product_summary').on('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      // Mark the clicked element as selected
      $(this).addClass('selected');

      let data = $(this).find('.cart').data();
      let price = $(this).find('.price').html();
      let image = $(this).find('.attachment-woocommerce_thumbnail').data('large_image');
      $('.modaal-content-container').addClass('product_add_on_modal');

      $('#title-modal-product').text(data.title);
      $('#price-modal-product').html(price);
      $('.img-product-on').attr('src', image);

      $('#modal_add_to_box').on('click', function () {
        // Use the selected element's button
        $('.selected').find('.add-to-box').click();
        $('.js-product-subscription-trigger').modaal('close');
        // Clear previous click selection (if any)
        $('.bundled_product_summary').removeClass('selected');
      });

    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    console.debug('landing subscription finalize');
  },
};


// WEBPACK FOOTER //
// ./scripts/routes/template-landing.js